export const LOAD_BIDDER_CARD_STATUS_FAIL = 'la/domain/user/bidderCardStatus/LOAD_FAIL';
export const LOAD_BIDDER_CARD_STATUS_REQUEST = 'la/domain/user/bidderCardStatus/LOAD_REQUEST';
export const LOAD_BIDDER_CARD_STATUS_SUCCESS = 'la/domain/user/bidderCardStatus/LOAD_SUCCESS';
